import type { InvestorPortalFeature, InvestorPortalSettings } from "../../../../api/types/investorPortalTypes";

export const allPortalPageStatuses = ["off", "preview", "live"] as const;
export type PortalPageStatus = (typeof allPortalPageStatuses)[number];

export const getPageStatusFromPortalSettings = (
  page: InvestorPortalFeature,
  portalSettings: InvestorPortalSettings
): PortalPageStatus => {
  if (portalSettings.enabledFeatures?.includes("All") || portalSettings.enabledFeatures?.includes(page)) {
    return "live";
  }
  if (portalSettings.enabledPreviewOnlyFeatures?.includes(page)) {
    return "preview";
  }
  return "off";
};
